import { sha256 } from 'js-sha256';

export default function createUniqueHash(session_salt, data) {
  if (!session_salt || !data) return;
  return sha256.hmac(session_salt, JSON.stringify(data));
}
